import { SubpageFoodCostHeader } from '@/components/food-cost/SubpageFoodCostHeader'
import { AsesoriaAudienceSection } from '@/features/asesoria/AsesoriaAudienceSection'
import { AsesoriaHeroSection } from '@/features/asesoria/AsesoriaHeroSection'
import { AsesoriaPricingSection } from '@/features/asesoria/AsesoriaPricingSection'
import { AsesoriaProblemSection } from '@/features/asesoria/AsesoriaProblemSection'
import { AsesoriaScopeSection } from '@/features/asesoria/AsesoriaScopeSection'
import { AsesoriaWaitlistSection } from '@/features/asesoria/AsesoriaWaitlistSection'
import {
    ANNUAL_PRICE_EUR,
    LANDING_PAGE,
    MONTHLY_PRICE_EUR,
    OG_IMAGE,
    formatPriceEur,
    scrollToId,
} from '@/features/asesoria/asesoriaTokens'
import { LocaleSeoLinks } from '@/navigation/LocaleSeoLinks'
import { ROUTES } from '@/navigation/constants'
import { useLandingLocale } from '@/navigation/useLandingLocale'
import { Footer } from '@/shared/ui/Footer'
import { PageHelmet } from '@/shared/ui/PageHelmet'
import '@/styles/food-cost-fonts.css'

export function AsesoriaPage() {
    const locale = useLandingLocale()
    const title = 'Asesoría Tipi · Hostelería rentable'
    const monthlyPriceLabel = formatPriceEur(MONTHLY_PRICE_EUR)
    const annualPriceLabel = formatPriceEur(ANNUAL_PRICE_EUR)
    const description = `Control completo de tu negocio de hostelería con Samuel Carrillo y Javier Porras. ${monthlyPriceLabel}/mes o ${annualPriceLabel} al año + 10 % de la mejora. Solo 1 cliente al mes. App incluida.`

    return (
        <div className="flex min-h-screen flex-col overflow-x-hidden bg-[#F5EEE4] font-['Archivo',system-ui,sans-serif] text-[17px] leading-normal text-[#17130E] antialiased">
            <LocaleSeoLinks path={ROUTES.asesoria} locale={locale} />
            <PageHelmet locale={locale}>
                <title>{title}</title>
                <meta name='description' content={description} />
                <meta property='og:type' content='website' />
                <meta property='og:title' content={title} />
                <meta property='og:description' content={description} />
                <meta property='og:image' content={OG_IMAGE} />
                <meta name='twitter:card' content='summary_large_image' />
                <meta name='twitter:title' content={title} />
                <meta name='twitter:description' content={description} />
                <meta name='twitter:image' content={OG_IMAGE} />
                <link
                    rel='preload'
                    href='/fonts/Archivo/archivo-latin.woff2'
                    as='font'
                    type='font/woff2'
                    crossOrigin='anonymous'
                />
            </PageHelmet>

            <SubpageFoodCostHeader
                landingPage={LANDING_PAGE}
                ctaLabel='Hablar con Tipi'
                onCtaClick={() => scrollToId('plaza')}
            />

            <main className='flex-1'>
                <AsesoriaHeroSection />
                <AsesoriaProblemSection />
                <AsesoriaScopeSection />
                <AsesoriaAudienceSection />
                <AsesoriaPricingSection />
                <AsesoriaWaitlistSection />
            </main>

            <Footer landingPage='asesoria' className='border-[#F5EEE4]/10 bg-[#17130E]' />
        </div>
    )
}
